import { z } from "zod";
import { ZForenkletEllerDetaljertEnumSchema } from "../byggSchema";

export const ZBygningsmessigEnergiSchema = z.object({
  // 6
  isActive: z.boolean().default(true),
  tekst: z.string(),
  lufttetthet: z.object({
    // 6.1
    isActive: z.boolean().default(true),
    tekst: z.string(),
    inputValue: z.number().nullable(),
    forenkletEllerDetaljert: ZForenkletEllerDetaljertEnumSchema,
  }),
  kuldebroer: z.object({
    // 6.2
    isActive: z.boolean().default(true),
    tekst: z.string(),
    inputValue: z.number().nullable(),
    prosjektspesifikkeKuldebroer: z.object({
      // 6.2.1
      isActive: z.boolean().default(true),
      tekst: z.string(),
    }),
  }),
});

export type IBygningsmessigEnergiSchema = z.infer<typeof ZBygningsmessigEnergiSchema>;
